<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Nominal EDC`" :modal-id="`modal-selengkapnya`" @close="back">
            <template v-slot:modal-body>
                <div>
                    Nominal yang ditampilkan mungkin berbeda dengan nominal sebenarnya di mesin EDC saat settlement,
                    karena nominal dihitung dari nota transaksi belum dikurangi dengan biaya MDR. Pengurangan biaya MDR
                    dihitung saat melakukan setoran di aplikasi.
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";

export default {
    name: "ModalSelengkapnya",
    components: {
        SOSlotModal,
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#modal-selengkapnya`).modal("show");
    },
    methods: {
        async back() {
            await this.$router.push({ name: "mesin.edc.list" });
        },
        closeModal() {
            $(`#modal-selengkapnya`).modal("hide");
        },
    },
};
</script>
